/**
 * Ids de correlação do front. Fonte ÚNICA — o `clientLog.ts` tinha uma cópia
 * privada; se o beacon e o axios reimplementassem, a sessão teria dois ids.
 *
 * Dois conceitos distintos, de propósito:
 * - **sessão** (`getSessionCorrelationId`): um id por ABA, memoizado em
 *   sessionStorage. Usado pelo beacon de telemetria e pelo clientLog.
 * - **request** (`novoCorrelationId`): um id NOVO por chamada HTTP. É o que vai
 *   no header `X-Correlation-Id`, porque o backend adota o header de entrada
 *   como correlation da request — mandar o id de sessão colapsaria todo
 *   `audit_log`/`log_evento` da sessão num valor só e mataria o cruzamento
 *   "evento de negócio ↔ erro técnico da MESMA request" (decisão 2026-08-19).
 */
const CHAVE_SESSAO = 'utilyhub:correlation-id';

/** 32 hex — mesmo formato do `Guid("N")` que o backend gera e trunca em 32. */
function gerar(): string {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID().replace(/-/g, '');
    }
  } catch {
    /* ambiente sem crypto — cai no fallback */
  }
  // Fallback sem crypto: repete até ter 32 chars.
  let s = '';
  while (s.length < 32) s += Math.random().toString(16).slice(2);
  return s.slice(0, 32);
}

export function novoCorrelationId(): string {
  return gerar();
}

export function getSessionCorrelationId(): string {
  try {
    const existente = sessionStorage.getItem(CHAVE_SESSAO);
    if (existente) return existente;
    const novo = gerar();
    sessionStorage.setItem(CHAVE_SESSAO, novo);
    return novo;
  } catch {
    // sessionStorage bloqueado (modo restrito / iframe): devolve um id efêmero
    // em vez de quebrar. A correlação some, o app não.
    return gerar();
  }
}
